import type { Project } from "./projectFile";
import { canonTable } from "./seatingOps";

// Builds what "Publish event" sends to the server for the Guest, Door Check and Booth Leads apps.
// The server cleans and size-limits it again; this only picks the right parts of the project.

export interface LiveExtras {
  venue: string;
  address: string;
  mapUrl: string;
  notes: string;
  announcements: { id: string; at: string; text: string }[];
}

export const emptyExtras = (): LiveExtras => ({ venue: "", address: "", mapUrl: "", notes: "", announcements: [] });

export function buildLiveSnapshot(project: Project, extras: LiveExtras) {
  const sessions = [...project.data.sessions].sort((a, b) => `${a.day} ${a.start}`.localeCompare(`${b.day} ${b.start}`));
  const first = sessions[0];
  const last = sessions[sessions.length - 1];
  return {
    event: {
      name: project.name,
      timeZone: project.timeZone,
      startsAt: first ? `${first.day} ${first.start}` : "",
      endsAt: last ? `${last.day} ${last.end || last.start}` : "",
      venue: extras.venue,
      address: extras.address,
      mapUrl: extras.mapUrl,
      notes: extras.notes,
    },
    programme: sessions.map((s) => ({
      id: s.id,
      time: s.end ? `${s.day} ${s.start}-${s.end}` : `${s.day} ${s.start}`,
      title: s.title,
      room: s.room ?? "",
      speaker: s.presenter ?? "",
      note: s.notes ?? "",
    })),
    announcements: extras.announcements.filter((a) => a.text.trim()),
    // names only, for door staff: no email, phone, dietary or other private fields leave the project
    guests: project.data.guests.map((g) => ({ id: g.id, name: g.name, ticket: g.table ? (/^Table \d/.test(canonTable(g.table)) ? canonTable(g.table) : `Table ${g.table}`) : g.role ?? "", status: g.status })),
    passKey: project.passKey,
  };
}

/** Where each app page lives. */
export const appUrl = (origin: string, role: "guest" | "door" | "booth", token: string) => `${origin}/apps/${role}/${token}`;
